import { Instance, SnapshotIn, types } from 'mobx-state-tree'
import { parseBackendUtcDateString } from 'utils/datetimeUtils'
import { ProfileModuleVersionModel } from './ProfileModuleVersionModel'

export const ProfileModel = types.model('ProfileModel', {
    id: types.identifier,
    title: types.string,
    // UTC ISO string from the backend, null when the profile has no release time
    release_timestamp: types.maybeNull(types.string),
    // Null when the profile was loaded from the profiles list (short profile), filled once the full profile is fetched
    module_versions: types.maybeNull(types.array(ProfileModuleVersionModel)),
})
.views(self => ({
    get releaseDate(): Date | null {
        return self.release_timestamp ? parseBackendUtcDateString(self.release_timestamp) : null
    },
}))

export type Profile = Instance<typeof ProfileModel>
export type ProfileSnapshotIn = SnapshotIn<typeof ProfileModel>
export type ShortProfileSnapshotIn = Omit<ProfileSnapshotIn, 'module_versions'>
